import { render, staticRenderFns } from "./IzvestajSipanjaGoriva.vue?vue&type=template&id=105f90c2&scoped=true&"
import script from "./IzvestajSipanjaGoriva.vue?vue&type=script&lang=ts&"
export * from "./IzvestajSipanjaGoriva.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105f90c2",
  null
  
)

export default component.exports